export function LogoMark({ className = "h-9 w-9", dark = false }) {
  return (
    <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
      <circle cx="45" cy="16" r="5" fill="#C86B4D" />
      <path
        d="M16 51V32a12 12 0 0 1 24 0v19"
        stroke={dark ? "#EAE5DC" : "#5A6B46"}
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M10 57c3.5-3 7-3 10.5 0s7 3 10.5 0 7-3 10.5 0 7 3 10.5 0"
        stroke="#C86B4D"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function Logo({ dark = false, compact = false }) {
  return (
    <span className="flex items-center gap-3">
      <LogoMark dark={dark} />
      {!compact && (
        <span
          className={`font-serif text-xl leading-none tracking-wide ${
            dark ? "text-sand" : "text-ink"
          }`}
        >
          Private Oasis <span className="italic text-terra">Villa</span>
        </span>
      )}
    </span>
  );
}
